import AdConsole from './AdConsole.tsx';
import AddTotal from './AddTotal.tsx';
import Admin from './Admin.tsx';
import Alliance from './Alliance.tsx';
import Angle from './Angle.tsx';
import AngleThin from './AngleThin.tsx';
import Approve from './Approve.tsx';
import Archive from './Archive.tsx';
import Arrow from './Arrow.tsx';
import ArrowDnd from './ArrowDnd.tsx';
import ArticleLength from './ArticleLength.tsx';
import Bag from './Bag.tsx';
import Ban from './Ban.tsx';
import BarChart from './BarChart.tsx';
import Billing from './Billing.tsx';
import Booked from './Booked.tsx';
import BusinessClick from './BusinessClick.tsx';
import Camera from './Camera.tsx';
import Cancel from './Cancel.tsx';
import Caret from './Caret.tsx';
import Check from './Check.tsx';
import CheckCircle from './CheckCircle.tsx';
import Checkmark from './Checkmark.tsx';
import Clipboard from './Clipboard.tsx';
import Close from './Close.tsx';
import Cloud from './Cloud.tsx';
import Code from './Code.tsx';
import Cogs from './Cogs.tsx';
import Coins from './Coins.tsx';
import CoinsAlt from './CoinsAlt.tsx';
import CoinsStack from './CoinsStack.tsx';
import Collapse from './Collapse.tsx';
import Columns from './Columns.tsx';
import Compass from './Compass.tsx';
import Copy from './Copy.tsx';
import CopyAlt from './CopyAlt.tsx';
import Cross from './Cross.tsx';
import Customer from './Customer.tsx';
import Dashboard from './Dashboard.tsx';
import Database from './Database.tsx';
import Desktop from './Desktop.tsx';
import Diskette from './Diskette.tsx';
import DollarAlt from './DollarAlt.tsx';
import DollarSign from './DollarSign.tsx';
import Dot from './Dot.tsx';
import DoubleArrow from './DoubleArrow.tsx';
import Download from './Download.tsx';
import DragIndicator from './DragIndicator.tsx';
import Edit from './Edit.tsx';
import EditAlt from './EditAlt.tsx';
import Ellipsis from './Ellipsis.tsx';
import Email from './Email.tsx';
import EmailAlt from './EmailAlt.tsx';
import Envelope from './Envelope.tsx';
import Error from './Error.tsx';
import ExcludeRow from './ExcludeRow.tsx';
import Expand from './Expand.tsx';
import Export from './Export.tsx';
import Facebook from './Facebook.tsx';
import FileDownload from './FileDownload.tsx';
import Files from './Files.tsx';
import FileSearch from './FileSearch.tsx';
import FileType from './FileType/index.tsx';
import Filter from './Filter.tsx';
import FilterRemove from './FilterRemove.tsx';
import Format from './Format.tsx';
import GetMoney from './GetMoney.tsx';
import GroupRow from './GroupRow.tsx';
import Hide from './Hide.tsx';
import Image from './Image.tsx';
import Import from './Import.tsx';
import Incomplete from './Incomplete.tsx';
import Indicator from './Indicator.tsx';
import Info from './Info.tsx';
import Information from './Information.tsx';
import Instagram from './Instagram.tsx';
import Laptop from './Laptop.tsx';
import Like from './Like.tsx';
import List from './List.tsx';
import ListAlt from './ListAlt.tsx';
import Loading from './Loading.tsx';
import Location from './Location.tsx';
import Locked from './Locked.tsx';
import Megaphone from './Megaphone.tsx';
import Messenger from './Messenger.tsx';
import Minus from './Minus.tsx';
import MinusCircle from './MinusCircle.tsx';
import MinusSquare from './MinusSquare.tsx';
import Mobile from './Mobile.tsx';
import More from './More.tsx';
import Move from './Move.tsx';
import Notes from './Notes.tsx';
import Paperclip from './Paperclip.tsx';
import PersonAdd from './PersonAdd.tsx';
import PersonRemove from './PersonRemove.tsx';
import Phone from './Phone.tsx';
import PhoneBook from './PhoneBook.tsx';
import Placeholder from './Placeholder.tsx';
import Play from './Play.tsx';
import Plus from './Plus.tsx';
import PlusCircle from './PlusCircle.tsx';
import PlusSquare from './PlusSquare.tsx';
import Pointer from './Pointer.tsx';
import PointerAlt from './PointerAlt.tsx';
import PriceTag from './PriceTag.tsx';
import Printer from './Printer.tsx';
import Process from './Process.tsx';
import ProjectStatus from './ProjectStatus.tsx';
import QuestionCircle from './QuestionCircle.tsx';
import Reload from './Reload.tsx';
import ReportLevelFirst from './ReportLevelFirst.tsx';
import ReportLevelSecond from './ReportLevelSecond.tsx';
import ReportLevelThird from './ReportLevelThird.tsx';
import ReportLevelThirdReverse from './ReportLevelThirdReverse.tsx';
import Reset from './Reset.tsx';
import Restore from './Restore.tsx';
import RowsLimit from './RowsLimit.tsx';
import Rss from './Rss.tsx';
import Ruler from './Ruler.tsx';
import Screenshot from './Screenshot.tsx';
import Search from './Search.tsx';
import Settings from './Settings.tsx';
import Shrink from './Shrink.tsx';
import Sort from './Sort.tsx';
import SortAsc from './SortAsc.tsx';
import SortBold from './SortBold.tsx';
import SortDesc from './SortDesc.tsx';
import Speed from './Speed.tsx';
import Stop from './Stop.tsx';
import Success from './Success.tsx';
import Sync from './Sync.tsx';
import TableSort from './TableSort.tsx';
import Tablet from './Tablet.tsx';
import TargetMan from './TargetMan.tsx';
import Trash from './Trash.tsx';
import Twitter from './Twitter.tsx';
import Unlocked from './Unlocked.tsx';
import User from './User.tsx';
import Users from './Users.tsx';
import Verified from './Verified.tsx';
import Views from './Views.tsx';
import ViewsFocus from './ViewsFocus.tsx';
import Visible from './Visible.tsx';
import Warning from './Warning.tsx';
import WarningCircle from './WarningCircle.tsx';
import WarningCircleAlt from './WarningCircleAlt.tsx';
import Xandr from './Xandr.tsx';
import Xing from './Xing.tsx';
import Youtube from './Youtube.tsx';

const Icons = {
  FileType,
  Admin,
  Alliance,
  Angle,
  AngleThin,
  Archive,
  Export,
  ArticleLength,
  Approve,
  AdConsole,
  AddTotal,
  Arrow,
  ArrowDnd,
  BarChart,
  Bag,
  Billing,
  Booked,
  Check,
  CheckCircle,
  Camera,
  Cancel,
  Caret,
  Close,
  Cloud,
  Columns,
  Database,
  Desktop,
  DollarSign,
  DollarAlt,
  Dot,
  DoubleArrow,
  Download,
  Import,
  Email,
  EmailAlt,
  Edit,
  EditAlt,
  Error,
  Facebook,
  Instagram,
  Indicator,
  Twitter,
  Xing,
  Youtube,
  FileSearch,
  Files,
  FilterRemove,
  Filter,
  Image,
  Info,
  Hide,
  Like,
  List,
  ListAlt,
  Megaphone,
  Move,
  Phone,
  Plus,
  PlusCircle,
  PlusSquare,
  Printer,
  Process,
  QuestionCircle,
  Rss,
  Success,
  TargetMan,
  Trash,
  Users,
  Warning,
  WarningCircle,
  WarningCircleAlt,
  Reset,
  Restore,
  Compass,
  BusinessClick,
  Notes,
  Dashboard,
  User,
  Settings,
  Copy,
  CopyAlt,
  Views,
  ViewsFocus,
  Verified,
  Clipboard,
  Sync,
  Play,
  Ban,
  Cogs,
  Coins,
  CoinsAlt,
  CoinsStack,
  Envelope,
  Ruler,
  Reload,
  Checkmark,
  Cross,
  Locked,
  Location,
  Loading,
  Minus,
  MinusCircle,
  MinusSquare,
  Unlocked,
  Messenger,
  Mobile,
  Information,
  Tablet,
  Incomplete,
  Search,
  Diskette,
  RowsLimit,
  GroupRow,
  TableSort,
  Sort,
  SortBold,
  SortAsc,
  SortDesc,
  Ellipsis,
  DragIndicator,
  FileDownload,
  ExcludeRow,
  Paperclip,
  PersonAdd,
  PersonRemove,
  PhoneBook,
  Customer,
  GetMoney,
  Pointer,
  PointerAlt,
  PriceTag,
  Format,
  Stop,
  More,
  Speed,
  Expand,
  Shrink,
  Visible,
  Xandr,
  Placeholder,
  ProjectStatus,
  Screenshot,
  Laptop,
  Code,
  Collapse,
  ReportLevelFirst,
  ReportLevelSecond,
  ReportLevelThird,
  ReportLevelThirdReverse,
};

export default Icons;
